import { Box, Flex } from "@jewlr/storybook/core"
import React from "react"
import styled from "styled-components"

import { jewlr_t } from "helpers/application"

const Step = styled(Box)`
  font-size: 12px;
  white-space: nowrap;
`

const CustomizeSteps = () => (
  <Box bg="polar">
    <Box contain>
      <Flex
        gutter={{ desktop: 7, tablet: 3 }}
        justifyContent={{ _: "space-around", tablet: "center" }}
        ml={0}
        mr={0}
        p={1}
      >
        <Step>1 | Select a Style</Step>
        <Step>2 | {jewlr_t("terms.Personalize")} It</Step>
        <Step>3 | Made For You</Step>
      </Flex>
    </Box>
  </Box>
)

CustomizeSteps.propTypes = {}

export default CustomizeSteps
